import clsx from 'clsx';
import React from 'react';

import { cn } from '@/src/util/ui';

type FieldWrapperProps = {
  label?;
  containerClassName?: string;
  labelClassName?: string;
  labelWidthClasses?: string;
  required?: boolean;
  children?: React.ReactNode;
};

const FieldWrapper = ({
  label,
  required,
  children,
  containerClassName = '',
  labelClassName = '',
  labelWidthClasses,
}: FieldWrapperProps) => {
  return (
    <React.Fragment>
      <div
        className={cn(
          'form-container',
          'tw-w-full',
          'tw-flex tw-items-center',
          'tw-mb-[10px]',
          containerClassName
        )}
      >
        {label && (
          <label
            className={cn(
              // (!) is not removed here as it is to override the styles from vendor.css
              'tw-font-brandonTextMedium !tw-font-normal',
              'tw-mb-0 tw-mr-[10px]',
              labelWidthClasses ? labelWidthClasses : 'tw-min-w-[70px] tw-max-w-[70px]',
              labelClassName
            )}
            htmlFor={label}
          >
            {label}
            {required && (
              <sup className={clsx('tw-top-[-2px]', 'tw-text-[15px] tw-text-cfo-red-400')}>*</sup>
            )}
          </label>
        )}
        {children}
      </div>
    </React.Fragment>
  );
};

export default FieldWrapper;
